import api from './BaseApi';
import dateFormat from '../utils/dateformat';

/**
 * Получить список покупок по типу и дате
 * @param {string} type - [recipes, ingredients]
 * @param {string} date - yyyy-mm-dd 
 */
export function getPurchasesListOnDate(payload) {
  payload.start_date = payload.start_date && dateFormat(payload.start_date, 'yyyy-mm-dd');
  payload.end_date = payload.end_date && dateFormat(payload.end_date, 'yyyy-mm-dd');
  return api.get('/shopping_list', payload);
}

/**
 * Работа с ингредиентом
 * 
 * Обязательные поля:
 * @param {string} date - yyyy-mm-dd
 * @param {string} ingredient_id - "6298a32e-c219-436d-9ee9-6d18e5503772",
 * 
 * Установить кулпен или нет:
 * @param {string} is_bought - ["t", "f"] - ус
 * 
 * Установить вес:
 * @param {number} weight
 */
export function setIngredientData(payload) {
  payload.start_date = payload.start_date && dateFormat(payload.start_date, 'yyyy-mm-dd');
  payload.end_date = payload.end_date && dateFormat(payload.end_date, 'yyyy-mm-dd');
  return api.post('shopping_list/ingredient/update', payload);
}

/**
 * Работа с рецептом
 * 
 * Обязательные поля:
 * @param {string} date - yyyy-mm-dd
 * @param {string} meal_id - "6298a32e-c219-436d-9ee9-6d18e5503772",
 * 
 * Установить количество гостей:
 * @param {number} guest_count
 * 
 * Отметить/снять все:
 * @param {string} is_bought - ["t", "f"] - ус
 * 
 * Спрятать показат
 * @param {string} is_hidden - ["t", "f"]
 */
export function setMealData(payload) {
  payload.start_date = payload.start_date && dateFormat(payload.start_date, 'yyyy-mm-dd');
  payload.end_date = payload.end_date && dateFormat(payload.end_date, 'yyyy-mm-dd');
  return api.post('shopping_list/meal/update', payload);
}